import { useListView } from '../../core/ListViewProvider'
import { FuncionariosListGrouping } from './FuncionariosListGrouping'
import { FuncionariosListSearchComponent } from './FuncionariosListSearchComponent'
import { FuncionariosListToolbar } from './FuncionariosListToolbar'

export const FuncionariosListHeader = () => {
  const { selected } = useListView()

  return (
    <div className='card-header border-0 pt-6'>
      <FuncionariosListSearchComponent
        actions={selected.length > 0 ? <FuncionariosListGrouping /> : <FuncionariosListToolbar />}
      />
    </div>
  )
}
